import React, { Component } from "react";
import { VideoListBody } from "./style";
import { colorPalette } from "../../color-palette";
import { Player, ScreenCard } from "../../components";
import { Pagination } from "antd";
// tslint:disable:jsx-no-multiline-js
interface Vstate {}
/**
 * 监控大屏页面
 * @author 马俊峰
 * @date 2020-08-11
 * @class VideoList
 * @extends {Component<{}, Vstate>}
 */
class VideoList extends Component<{}, Vstate> {
  render() {
    return(
      <VideoListBody colorPalette={colorPalette}>
        <div className="video-box">
          {[1, 1, 1, 1].map((item, index) => (
            <ScreenCard className="video-item" key={index} colorPalette={colorPalette}>
              <Player url="http://zengcheng.fm-dev.gagogroup.cn:31090/api/v1/device/video" />
            </ScreenCard>
          ))}
        </div>
        <div className="pagain-box">
          <Pagination total={50} />
        </div>
      </VideoListBody>
    );
  }
}
export default VideoList;
